import { useCallback } from 'react';
import ScribeDuck from 'ducks/scribe-duck';
import { useDispatch } from 'react-redux';

export const useHandleScribeOffers = offerConfig => {
  const dispatch = useDispatch();

  const handleScribeSelectOffer = useCallback(
    ({ offerID, isPromoSearch, isOfferAvailable }) => {
      if (isPromoSearch) {
        dispatch(
          ScribeDuck.creators.scribeExpressEnterCodeDetailsSelectOffer(
            offerConfig,
            !isOfferAvailable,
          ),
        );
      } else {
        dispatch(
          ScribeDuck.creators.scribeExpressReviewOfferListSelectOffer(
            offerConfig,
            offerID,
          ),
        );
      }
    },
    [dispatch, offerConfig],
  );

  const handleScribeOfferDetailDefault = useCallback(
    ({ offerID }) => {
      dispatch(
        ScribeDuck.creators.scribeExpressOfferDetailsDefault(
          offerConfig,
          offerID,
        ),
      );
    },
    [offerConfig],
  );

  const handleScribeApplyOffer = useCallback(
    ({ offerID, isPromoSearch, isOfferAvailable }) => {
      if (isPromoSearch) {
        dispatch(
          ScribeDuck.creators.scribeExpressEnterCodeDetailsApplyOffer(
            offerConfig,
            false,
            !isOfferAvailable,
          ),
        );
      }
    },
    [dispatch, offerConfig],
  );

  const handleScribeContinueWithoutOffer = useCallback(() => {
    dispatch(
      ScribeDuck.creators.scribeExpressReviewOfferListContinueWithoutOffer(
        null,
      ),
    );
  }, []);

  const handleScribeOfferDetailBack = useCallback(
    ({ offerID }) => {
      dispatch(
        ScribeDuck.creators.scribeExpressOfferDetailsBack(offerConfig, offerID),
      );
    },
    [offerConfig],
  );

  const handleScribeOfferDetailUseOffer = useCallback(
    () => {
      dispatch(
        ScribeDuck.creators.scribeExpressOfferDetailsUseOffer(offerConfig),
      );
    },
    [offerConfig],
  );

  const handleScribeEnterCodeDetailsBack = useCallback(
    () => {
      dispatch(
        ScribeDuck.creators.scribeExpressEnterCodeDetailsBack(offerConfig),
      );
    },
    [offerConfig],
  );

  const handleScribeEnterCodeDetailsTypeCode = useCallback(
    ({ promoCode }) => {
      dispatch(
        ScribeDuck.creators.scribeExpressEnterCodeDetailsTypeCode(
          offerConfig,
          promoCode,
        ),
      );
    },
    [offerConfig],
  );

  const handleScribeEnterCodeDetailsShowErrorResult = useCallback(
    ({ promoKeyword, isNoResult }) => {
      dispatch(
        ScribeDuck.creators.scribeExpressEnterCodeDetailsShowErrorResult(
          offerConfig,
          promoKeyword,
          isNoResult,
        ),
      );
    },
    [offerConfig],
  );
  return {
    handleScribeSelectOffer,
    handleScribeOfferDetailDefault,
    handleScribeApplyOffer,
    handleScribeContinueWithoutOffer,
    handleScribeOfferDetailBack,
    handleScribeOfferDetailUseOffer,
    handleScribeEnterCodeDetailsBack,
    handleScribeEnterCodeDetailsTypeCode,
    handleScribeEnterCodeDetailsShowErrorResult,
  };
};

export default useHandleScribeOffers;
